import * as ActionTypes from './action-types.constants';

export const animate = (height) => ({
	type: ActionTypes.ANIMATE,
	height
})


export const ready = (container, upNext) => {
	return {
		type: ActionTypes.READY,
		container,
		upNext
	}
}

export const update = (upNext) => {
	return {
		type: ActionTypes.UPDATE,
		upNext
	}
}
export const destroy = () => {
	return {
		type: ActionTypes.DESTROY
	}
}

export const changeIntersection = ( isIntersecting, offsetHeight = 0 ) => {
	return {
		type: ActionTypes.INTERSECTION_CHANGE,
		isIntersecting,
		offsetHeight
	}
}